import { render } from "./brandSeeAllBtn.vue?vue&type=template&id=14979776"
import script from "./brandSeeAllBtn.vue?vue&type=script&lang=js"
export * from "./brandSeeAllBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__